const telegramCurrencies = require("./telegram/currencies.json");
const cryptoCurrencies = require("./crypto/currencies.json");
const otherCurrencies = require("./other/currencies.json");

// WHEN ADDING A NEW CURRENCY
// 1. Check availability:
// https://docs.stripe.com/currencies
// https://developer.paypal.com/docs/reports/reference/paypal-supported-currencies/
// https://www.skrill.com/fileadmin/content/pdf/Skrill_Automated_Payments_Interface_Guide.pdf
// 2. Add to availableCurrencies
// 3. Add to paypalCurrencies if supported by PayPal

// exports.availableCurrencies = [
// 	"USD",
// 	"EUR",
// 	"JPY",
// 	"GBP",
// 	"AUD",
// 	"CAD",
// 	"CHF",
// 	"CNY",
// 	"SEK",
// 	"NZD",
// 	"MXN",
// 	"SGD",
// 	"HKD",
// 	"NOK",
// 	"KRW",
// 	"TRY",
// 	"RUB",
// 	"INR",
// 	"BRL",
// 	"ZAR",
// 	"MYR",
// 	"NGN",
// 	"GHS",
// 	"CZK",
// 	"THB",
// 	"PHP",
// 	"IDR",
// 	"PLN",
// 	"SAR",
// 	"ILS",
// 	"KES",
// 	"RON",
// 	"BGN",
// 	"DKK",
// 	"HUF",
// 	"AED",
// 	"QAR",
// 	"XTR",
// 	"BTC"
// ]; // https://en.wikipedia.org/wiki/Template:Most_traded_currencies


exports.stripeCurrencies = [
	"USD", "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD",
	"BDT", "BGN", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BWP", "BYN", "BZD", "CAD", "CDF",
	"CHF", "CLP", "CNY", "COP", "CRC", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ETB",
	"EUR", "FJD", "FKP", "GBP", "GEL", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG",
	"HUF", "IDR", "ILS", "INR", "ISK", "JMD", "JPY", "KES", "KGS", "KHR", "KMF", "KRW", "KYD",
	"KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP",
	"MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "PAB",
	"PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD",
	"SCR", "SEK", "SGD", "SHP", "SLE", "SOS", "SRD", "STD", "SZL", "THB", "TJS", "TOP", "TRY",
	"TTD", "TWD", "TZS", "UAH", "UGX", "UYU", "UZS", "VND", "VUV", "WST", "XAF", "XCD", "XOF",
	"XPF", "YER", "ZAR", "ZMW"
];

exports.paypalCurrencies = [
	"AUD", // Australian dollar
	"BRL", // Brazilian real
	"CAD", // Canadian dollar
	"CNY", // Chinese Renmenbi
	"CZK", // Czech koruna
	"DKK", // Danish krone
	"EUR", // Euro
	"HKD", // Hong Kong dollar
	"HUF", // Hungarian forint
	"ILS", // Israeli new shekel
	"JPY", // Japanese yen
	"MYR", // Malaysian ringgit
	"MXN", // Mexican peso
	"TWD", // New Taiwan dollar
	"NZD", // New Zealand dollar
	"NOK", // Norwegian krone
	"PHP", // Philippine peso
	"PLN", // Polish złoty
	"GBP", // Pound sterling
	"RUB", // Russian ruble
	"SGD", // Singapore dollar
	"SEK", // Swedish krona
	"CHF", // Swiss franc
	"THB", // Thai baht
	"USD"  // United States dollar
];

exports.skrillCurrencies = [
	"AED", // Utd. Arab Emir. Dirham
	"MAD", // Moroccan Dirham
	"AUD", // Australian Dollar
	"MYR", // Malaysian Ringgit
	"BGN", // Bulgarian Leva
	"NOK", // Norwegian Krone
	"BHD", // Bahraini Dinar
	"NZD", // New Zealand Dollar
	"CAD", // Canadian Dollar
	"OMR", // Omani Rial
	"CHF", // Swiss Franc
	"PLN", // Polish Zloty
	"CZK", // Czech Koruna
	"QAR", // Qatari Rial
	"DKK", // Danish Krone
	"RON", // Romanian Leu
	"EUR", // Euro
	"RSD", // Serbian Dinar
	"GBP", // British Pound
	"SAR", // Saudi Riyal
	"HKD", // Hong Kong Dollar
	"SEK", // Swedish Krona
	"HRK", // Croatian Kuna
	"SGD", // Singapore Dollar
	"HUF", // Hungarian Forint
	"THB", // Thailand Baht
	"ILS", // Israeli Shekel
	"TND", // Tunisian Dinar
	"INR", // Indian Rupee
	"TRY", // New Turkish Lira
	"ISK", // Iceland Krona
	"TWD", // Taiwan Dollar
	"JOD", // Jordanian Dinar
	"USD", // U.S. Dollar
	"JPY", // Japanese Yen
	"ZAR", // South-African Rand
	"KRW", // South-Korean Won
	"COP", // Colombian Peso
	"KWD"  // Kuwaiti Dinar
];

exports.paystackCurrencies = [
	"NGN", //Nigerian Naira
	"USD", // United States Dollar
	"GHS", // Ghanaian Cedi
	"ZAR", // South African Rand
	"KES", // Kenyan Shilling
]

exports.razorpayCurrencies = ["INR"];

exports.restrictedCurrencies = [
	"SLE" // not used anymore
];

exports.availableFiatCurrencies = Array.from(
	new Set([
		...exports.stripeCurrencies,
		...exports.paypalCurrencies,
		...exports.skrillCurrencies,
		...exports.paystackCurrencies,
		...exports.razorpayCurrencies
	])
).filter(currency => !exports.restrictedCurrencies.includes(currency));

exports.availableCryptoCurrencies = ["BTC"];
exports.availableOtherCurrencies = ["XTR"];

exports.top10FiatCurrencies = ["USD", "EUR", "JPY", "GBP", "AUD", "CAD", "CHF", "CNY", "SEK", "NZD"];

exports.top30Cryptocurrencies = [
	"BTC",  // Bitcoin
	"ETH",  // Ethereum
	"USDT", // Tether
	"XRP",  // XRP
	"SOL",  // Solana
	"BNB",  // Binance Coin
	"DOGE", // Dogecoin
	"USDC", // USD Coin
	"ADA",  // Cardano
	"TRX",  // TRON
	"AVAX", // Avalanche
	"LINK", // Chainlink
	"SHIB", // Shiba Inu
	"TON",  // Toncoin
	"SUI",  // Sui
	"DOT",  // Polkadot
	"XLM",  // Stellar Lumens
	"HBAR", // Hedera Hashgraph
	"BCH",  // Bitcoin Cash
	"UNI",  // Uniswap
	"PEPE", // Pepe
	"LEO",  // Unus Sed Leo
	"LTC",  // Litecoin
	"NEAR", // NEAR Protocol
	"APT",  // Aptos
	"ICP",  // Internet Computer
	"USDe", // Ethena USDe
	"DYDX", // dYdX (Native)
	"IOTA", // IOTA
	"BSV"   // Bitcoin SV
];

exports.availableCurrencies = exports.availableFiatCurrencies.concat(exports.availableCryptoCurrencies).concat(exports.availableOtherCurrencies);

let getCurrency = (code) => {
	// console.log("In getCurrency", code);
	if (telegramCurrencies[code.toUpperCase()]) {
		return telegramCurrencies[code.toUpperCase()];
	} else if (cryptoCurrencies[code.toUpperCase()]) {
		return cryptoCurrencies[code.toUpperCase()];
	} else if (otherCurrencies[code.toUpperCase()]) {
		return otherCurrencies[code.toUpperCase()];
	} else {
		console.log("Currency not found, code=" + code + ". Fallback.");
		return {
			"code": code,
			"title": code,
			"symbol": code,
			"native": code,
			"thousands_sep": "",
			"decimal_sep": ".",
			"symbol_left": false,
			"space_between": true,
			"exp": 8,
			"min_amount": "0",
			"max_amount": "10000000000000000"
		}
	}
};

exports.isFiat = (code) => {
	return !!telegramCurrencies[code.toUpperCase()] || !!otherCurrencies[code.toUpperCase()];
};

exports.isCrypto = (code) => {
	return !!cryptoCurrencies[code.toUpperCase()];
};

exports.getCurrencyTitle = code => {
	return getCurrency(code).title;
};

exports.getCurrencyCodeTitle = code => {
	return code + " (" + getCurrency(code).title + ")";
};

exports.getCurrencyDecimalSep = code => {
	return getCurrency(code).decimal_sep;
};

exports.getCurrencyExp = code => {
	return getCurrency(code).exp;
};

exports.toFixed = (amount, currency) => {
	let exp = 8;
	try {
		exp = exports.getCurrencyExp(currency);
	} catch (e) {
		console.log("Failed to find proper exp for currency " + currency + ", reverting to default 8")
	}
	return amount.toFixed(exp);
}

exports.priceToSmallestUnits = (price, code) => {
	let priceSmallestUnits = Math.floor(Math.pow(10, getCurrency(code).exp) * price);
	return priceSmallestUnits
};

exports.priceFromSmallestUnits = (priceSmallestUnits, code) => {
	let price = priceSmallestUnits / Math.pow(10, getCurrency(code).exp);
	return price
};

exports.getCurrencyPriceIntervalString = code => {
	let strInterval =
		(getCurrency(code).min_amount / Math.pow(10, getCurrency(code).exp)).toFixed(getCurrency(code).exp) +
		"-" +
		(getCurrency(code).max_amount / Math.pow(10, getCurrency(code).exp)).toFixed(getCurrency(code).exp);
	return exports.formatPriceBase(strInterval, code)
};

exports.formatPriceBase = (price, code) => {
	let space = getCurrency(code).space_between ? " " : "";
	if (getCurrency(code).symbol_left) {
		return getCurrency(code).symbol + space + price;
	} else {
		return price + space + getCurrency(code).symbol;
	}
};

exports.formatPriceNoCode = (price, code) => {
	let strPrice = getCurrency(code).exp > 0 ? price.toFixed(getCurrency(code).exp) : price.toString();

	if (code === "BTC" || code === "XTR") { // special case
		strPrice = price.toString();
	}

	if (getCurrency(code).decimal_sep !== ".") {
		strPrice = strPrice.replace(".", getCurrency(code).decimal_sep);
	}
	return strPrice.replace(/\B(?=(\d{3})+(?!\d))/g, getCurrency(code).thousands_sep);
};

exports.formatPrice = (price, code) => {
	return exports.formatPriceBase(exports.formatPriceNoCode(price, code), code)
};

exports.getCurrencyMinAmount = code => {
	return getCurrency(code).min_amount;
};

exports.getCurrencyMaxAmount = code => {
	return getCurrency(code).max_amount;
};


exports.getMethodBaseCurrency = method => {
	if (method == "stripe") {
		return "USD"
	} else {
		throw new Error("I don't know default currency for this method")
	}
};

exports.calcAmountInCents = (amount, currency) => {
	return Math.round(amount * Math.pow(10, getCurrency(currency).exp));
};

exports.convertToCurrency = async (currencyFrom, currencyTo, amount) => {
	// TODO use API
};

exports.getCurrencySymbol = code => {
	return getCurrency(code).symbol;
};
